import React, { ReactNode, useCallback } from "react";
import styled from "styled-components";

import { useAttribution } from "../../hooks/useAttribution";
import { Routes } from "../../route/routes";
import MicrosoftLogo from "../../static/integration/microsoft-logo.inline.svg";
import { LoginOption } from "../login/LoginOption";

const MicrosoftIcon = styled(MicrosoftLogo)`
  width: 22px;
  height: 22px;
`;

interface AzureSignupProps {
  authQueryParams: Record<string, string>;
  children?: ReactNode;
  onSubmit: () => void;
  disabled?: boolean;
}

export const AzureSignup: React.ComponentType<AzureSignupProps> = React.memo(
  function AzureSignup({
    authQueryParams,
    children,
    disabled = false,
    onSubmit,
  }) {
    const attribution = useAttribution();
    const azureCallback = useCallback(async () => {
      onSubmit();
      const url = Routes.AZURE_SIGNUP.getUrl({
        attribution,
        queryParams: authQueryParams,
      });
      window.location.href = url;
    }, [authQueryParams, onSubmit, attribution]);

    return (
      <LoginOption
        disabled={disabled}
        icon={<MicrosoftIcon />}
        onClick={azureCallback}
      >
        {children ?? (
          <>
            Sign up with <span>Microsoft</span>
          </>
        )}
      </LoginOption>
    );
  },
);
